import { getHttpClient, NonCustodialProviderManagementApi } from '@capsicum/common';

export const ncWalletApi = getHttpClient.then(client => new NonCustodialProviderManagementApi(client));
